export const enrollSkus = {
  ambPremiumSku: 'ERL001',
  ambBasicSku: 'ERL002',
  arq: 'E035',
  myQFit: 'E036',
  pcFee: 'PCFEE',
}
